module.exports = __webpack_public_path__ + "img/icon-step-3-summary-payment.421994e4.svg";